<template>
  <el-header style="text-align: right; font-size: 12px;">
    <div class="logo-container">
      <img src="../assets/signing-white.png" width="130" />
    </div>
    <div class="other-content-left">
      <slot name="left"></slot>
    </div>
    <div class="other-content-right">
      <slot name="right"></slot>
    </div>
    <el-dropdown @command="onCommand">
      <div class="clickable white">
        <span>{{name}}</span>
        <i class="el-icon-setting" style="margin-left: 10px"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="update">編輯</el-dropdown-item>
        <el-dropdown-item command="logout">登出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-header>
</template>

<script>
export default {
  computed: {
    name () {
      return this.$store.state.admin.Profile.Name
    }
  },
  methods: {
    onCommand (command) {
      if (command === 'logout') this.askLogout()
      else if (command === 'update') this.$router.push({ name: 'profile' })
    },
    askLogout () {
      this.$confirm(`確定登出?`, '登出', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.logout()
        })
        .catch(_ => {})
    },
    logout () {
      this.$services.auth.logout(this)
      this.goLogin()
    },
    goLogin () {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style>
.el-header {
  background-color: #000;
  color: #333;
  line-height: 60px;
}

.other-content-left {
  text-align: left;
  display: inline-block;
  left: 200px;
  position: absolute;
  height: 60px;
}

.other-content-right {
  text-align: right;
  display: inline;
  height: 60px;
}

.logo-container {
  text-align: left;
  width: 200px;
  height: 60px;
  left: 0;
  position: absolute;

  display: inline-flex;
  justify-content: center;
  align-items: center;
}
</style>
